/**
 * scripts.js
 */
import $ from "jquery";
import Drupal from "Drupal";
import drupalSettings from "drupalSettings";
import {preventDefault} from "ol/events/Event";
import {display} from "@splidejs/splide/src/js/utils";


(function ($, Drupal, drupalSettings) {

  'use strict';

  Drupal.behaviors.viewportEffects = {
    attach: function (context, settings) {
        once('viewportEffects','div',context).forEach(function(){
          const inViewport = (entries, observer) => {
            entries.forEach(entry => {
              entry.target.classList.toggle("is-inViewport", entry.isIntersecting);
            });
          };

          const Obs = new IntersectionObserver(inViewport);
          const obsOptions = {}; //See: https://developer.mozilla.org/en-US/docs/Web/API/Intersection_Observer_API#Intersection_observer_options

          // Attach observer to every [data-inviewport] element:
          const ELs_inViewport = document.querySelectorAll('[data-inviewport]');
          ELs_inViewport.forEach(EL => {
            Obs.observe(EL, obsOptions);
          });
        })


    }
  }
})(jQuery, Drupal, drupalSettings);
